import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useGetMeQuery } from '../store/redux/api/accountApi';
import PassesListPage from '../pages/client/PassesListPage';
import PassesViewPage from '../pages/client/PassesViewPage';
import PassesEditPage from '../pages/client/PassesEditPage';
import PassesCreatePage from '../pages/client/PassesCreatePage';

const FeatureFlagGuard = ({
  children,
  flagKey,
  path,
  redirectOnError = true,
  redirectOnDisabled = true,
}) => {
  const { data: me, isLoading, isFetching, isError } = useGetMeQuery();

  const showNewPassesPage =
    Boolean(me?.pass_builder_enabled) ||
    Boolean(me?.pass_builder_enabled_internal);

  if (isLoading || isFetching) return null;

  if (isError || !me) {
    return redirectOnError ? <Navigate to="/dashboard" replace /> : null;
  }

  const flag = Boolean(me?.[flagKey]);
  const subscribed = Boolean(me?.subscribed);

  if (flagKey === 'billing_enabled') {
    const isOnCardlessTrial =
      me?.cardless_trial_started_at &&
      (me?.organisation_status === 'trial' ||
        me?.organisation_status === 'trial_expired');

    if (isOnCardlessTrial) {
      return redirectOnDisabled ? <Navigate to="/dashboard" replace /> : null;
    }
    if (subscribed || flag) {
      return children;
    }
  }

  if (flagKey === 'pass_builder_enabled') {
    if (path === '/passes') {
      return showNewPassesPage ? children : <PassesListPage />;
    }
    if (path === '/passes/:uuid') {
      return showNewPassesPage ? children : <PassesViewPage />;
    }
    if (path === '/passes/edit/:uuid') {
      return showNewPassesPage ? children : <PassesEditPage />;
    }
    if (path === '/passes/create') {
      return showNewPassesPage ? children : <PassesCreatePage />;
    }
  }

  if (!flag) {
    return redirectOnDisabled ? <Navigate to="/dashboard" replace /> : null;
  }

  return children;
};

FeatureFlagGuard.propTypes = {
  children: PropTypes.node.isRequired,
  flagKey: PropTypes.string.isRequired,
  redirectOnError: PropTypes.bool,
  redirectOnDisabled: PropTypes.bool,
  path: PropTypes.string,
};

export default FeatureFlagGuard;
